export default "assets/images/chateaux-logos/rahoul-c665e0e0.png";